// src/services/pos.js
// Add this file to frontend/src/services/
import api from './api';

export const getPOSTypes       = ()       => api.get('/pos/types');
export const getConnection     = ()       => api.get('/pos/connection');
export const saveConnection    = (data)   => api.post('/pos/connection', data);
export const testConnection    = ()       => api.post('/pos/connection/test');
export const deleteConnection  = ()       => api.delete('/pos/connection');
export const syncMenu          = ()       => api.post('/pos/sync/menu');
export const syncCSV           = (csv)    => api.post('/pos/sync/csv', { csvContent: csv });
export const getSyncLogs       = ()       => api.get('/pos/logs');
export const getWebhookUrl     = ()       => api.get('/pos/webhook-url');

// Mall-admin: manage vendor POS credentials on their behalf
export const getMallVendorPOS       = (mallId, vendorId)       => api.get(`/mall/${mallId}/vendors/${vendorId}/pos`);
export const saveMallVendorPOS      = (mallId, vendorId, data) => api.post(`/mall/${mallId}/vendors/${vendorId}/pos`, data);
export const toggleMallVendorPOSPush = (mallId, vendorId)      => api.patch(`/mall/${mallId}/vendors/${vendorId}/pos/toggle`);
